import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { vs2015 } from 'react-syntax-highlighter/dist/esm/styles/hljs';

/**
 * Shared dark, syntax-highlighted code block used across the Docs tabs
 * (Querying, Logging). Fills its container edge-to-edge on a solid dark
 * background so it can sit inside a padding-less Card without any white border.
 *
 * @param {Object} props
 * @param {string} props.code - The code string to render.
 * @param {string} props.language - highlight.js language id (e.g. 'python',
 *   'typescript', 'go'); falls back to plain text when unknown.
 */
const HighlightedCode = ({ code, language }) => (
    <div style={{ background: '#1e1e1e', overflowX: 'auto', maxWidth: '100%' }}>
        <SyntaxHighlighter
            language={language || 'text'}
            style={vs2015}
            customStyle={{
                margin: 0,
                padding: '1rem',
                // Leave room for the absolutely-positioned selector/action toolbar.
                paddingTop: '3rem',
                background: '#1e1e1e',
                overflowX: 'auto',
            }}
            codeTagProps={{ style: { fontFamily: 'monospace' } }}
        >
            {code}
        </SyntaxHighlighter>
    </div>
);

export default HighlightedCode;
